import { APP_MODE_PRODUCTION } from '../environment'

export * from './activity-state'
export * from './reatom'
export * from './paginated'

/**
 * For debugging purposes only
 */
export const addToGlobal = (key: string, value: unknown) => {
  if (typeof window !== 'undefined' && !APP_MODE_PRODUCTION) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ;(window as any)[key] = value
  }
}

export const tryOrFailSilently = (fn: () => unknown) => {
  try {
    fn()
  } catch {
    //
  }
}
